export default function Error(props) {
  return (
    <div className="error-container">
      <h1>{props.msg}</h1>
    </div>
  );
}
